import { defineMessages, IntlShape } from 'react-intl';

const messages = defineMessages({
  navigation: {
    id: 'Navigation',
    defaultMessage: 'Navigation',
  },
  search: {
    id: 'Show search input',
    defaultMessage: 'Show search input',
  },
  topLevel: {
    id: 'mpf_context_navigation_top_level',
    defaultMessage: 'Nível inicial',
  },
  topLevelDescription: {
    id: 'mpf_context_navigation_top_level_description',
    defaultMessage:
      'Nível do site em que o menu começa. 1 mostra a seção inteira; 3 em Unidades mostra só a unidade aberta. Vale para as páginas abaixo desta. Acima do nível, o menu volta ao nível 1.',
  },
  topLevelSection: {
    id: 'mpf_context_navigation_top_level_section',
    defaultMessage: '1 (seção)',
  },
});

export const TOP_LEVEL_CHOICES = ['1', '2', '3', '4'];

interface SchemaContextNavigationProps {
  intl: IntlShape;
}

interface SchemaField {
  title: string;
  type?: string;
  description?: string;
  default?: boolean | string;
  choices?: [string, string][];
  noValueOption?: boolean;
}

interface Schema {
  title: string;
  fieldsets: { id: string; title: string; fields: string[] }[];
  required: string[];
  properties: {
    showSearchInput: SchemaField;
    topLevel: SchemaField;
  };
}

const schemaContextNavigation = ({
  intl,
}: SchemaContextNavigationProps): Schema => {
  return {
    title: intl.formatMessage(messages.navigation),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['topLevel', 'showSearchInput'],
      },
    ],
    required: [],
    properties: {
      showSearchInput: {
        title: intl.formatMessage(messages.search),
        type: 'boolean',
        default: false,
      },
      topLevel: {
        title: intl.formatMessage(messages.topLevel),
        description: intl.formatMessage(messages.topLevelDescription),
        choices: TOP_LEVEL_CHOICES.map((level) => [
          level,
          level === '1' ? intl.formatMessage(messages.topLevelSection) : level,
        ]),
        default: '2',
        noValueOption: false,
      },
    },
  };
};

export default schemaContextNavigation;
